import { render, staticRenderFns } from "./SubtasksNew.vue?vue&type=template&id=799a9d91&scoped=true&"
import script from "./SubtasksNew.vue?vue&type=script&lang=js&"
export * from "./SubtasksNew.vue?vue&type=script&lang=js&"
import style0 from "./SubtasksNew.vue?vue&type=style&index=0&id=799a9d91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a9d91",
  null
  
)

export default component.exports